import { DateTime } from 'luxon';

export const toUtc = (date: Date): Date => {
  const localDateTime = DateTime.fromJSDate(date, {
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  const utcDateTime = localDateTime.toUTC().toJSDate();

  return utcDateTime;
};

export const toLocalIso = (date: Date): string => {
  const localDateTime = DateTime.fromJSDate(date, {
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  return localDateTime.toISODate()!;
};
